import { useEffect, useMemo, useState } from "react";
import { SimpleInstalledApplicationDetail } from "../types/SimpleInstalledApplicationDetail";
import { useTypedSelector } from "../../../app/store";
import { useDispatch } from "react-redux";
import { fetchInstalledApps } from "../InstalledAppSlice";
import axios from "axios";

export const useInstalledAppList = () => {
  const wholeState = useTypedSelector((x) => ({
    ...x.login,
    ...x.installedApplication,
  }));
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);

  const apps: SimpleInstalledApplicationDetail[] = useMemo(() => {
    const tempApps = wholeState.installedApps.installedApplications;

    // stateから取得した連携アプリ一覧の中に不正なものがあれば除外する
    if (!tempApps) return [];
    return tempApps.filter(
      (app): app is SimpleInstalledApplicationDetail =>
        !!app.name && !!app.applicationId && !!app.description
    );
  }, [wholeState.installedApps.installedApplications]);

  const meta = useMemo(() => {
    return wholeState.installedApps.meta ?? { total: 0 };
  }, [wholeState.installedApps.meta]);

  // ロード状態を反映
  useEffect(() => {
    // ちらつき防止で0.5秒遅らせる
    const delay = setTimeout(() => {
      setIsLoading(wholeState.isLoadings.fetchInstalledApps);
    }, 500);

    // アンマウント
    return () => {
      clearTimeout(delay);
    };
  }, [wholeState.isLoadings.fetchInstalledApps]);

  // マウント
  useEffect(() => {
    const source = axios.CancelToken.source();

    dispatch(
      fetchInstalledApps({
        accessToken: wholeState.accessToken!,
        cancelToken: source.token,
      })
    );

    // アンマウント
    return () => {
      // リクエスト中ならキャンセル
      source.cancel();
    };
  }, [dispatch, wholeState.accessToken]);

  return { apps, meta, isLoading };
};
